<template>
	<Modal
			:value="showImportProps"
			@on-cancel="hideUpload"
			:title="title"
			width="400">
		<Upload
				ref="upload"
				:data="uploadtData"
				:action="actionUrl"
				:format="format"
				:max-size="5012"
				:on-progress="onProgress"
				:on-success="handleSuccess"
				:on-format-error="handleFormatError"
				:before-upload="beforeUpload"
				:on-exceeded-size="handleMaxSize"
				:show-upload-list="false"
		>
			<Button type="ghost" icon="ios-cloud-upload-outline">上传文件</Button>
		</Upload>
		<div v-if="currentFile" :class="fileCls(currentFile)">
			<span>
                <Icon :type="formatIcon(currentFile)"></Icon> {{ currentFile.name }}
            </span>
			<transition name="fade">
				<Progress v-if="showProgress" :status="loadingStatus" :percent="loadingPrecent" :stroke-width="4"></Progress>
			</transition>
		</div>
		<div class="oms-detail-wra" v-show="errorData.show">
			<div class="oms-content-wra">
				<p v-for="item in errorData.data" :key="item">{{item}}</p>
			</div>
		</div>
		<div slot="footer">
			<Button size="large" @click="hideUpload">关闭</Button>
		</div>
	</Modal>
</template>

<script>
import {Cookie} from 'libs/js/cookie'

export default {
    name: 'mgrUpload',
    data() {
        return {
            uploadtData: {},
            errorData: {
                show: false,
                data: []
            },
            currentFile: null,
            loadingPrecent: 0,
            loadingStatus: 'normal',
            showProgress: false
        }
    },
    props: {
        showImportProps: {
            required: true,
            type: Boolean
        },
        actionUrl: {
            required: true,
            type: String
        },
        title: {
            default: '订单导入'
        },
        format: {
            type: Array,
            default: function() {
                return ['xls', 'xlsx', 'xlsm', 'grf','json','apk']
            }
        }
    },
    mounted() {
        this.errorData.show = false
        this.errorData.data = []
        this.$refs.upload.clearFiles()
    },
    methods: {
        fileCls(file) {
            return [
                `ivu-upload-list-file`,
                {
                    [`ivu-upload-list-file-finish`]: file.status === 'finished'
                }
            ]
        },
        formatIcon(file) {
            const format = file.name.split('.').pop().toLocaleLowerCase() || ''
            let type = 'document'

            if (['gif', 'jpg', 'jpeg', 'png', 'bmp', 'webp'].indexOf(format) > -1) {
                type = 'image'
            }
            if (['mp4', 'm3u8', 'rmvb', 'avi', 'swf', '3gp', 'mkv', 'flv'].indexOf(format) > -1) {
                type = 'ios-film'
            }
            if (['mp3', 'wav', 'wma', 'ogg', 'aac', 'flac'].indexOf(format) > -1) {
                type = 'ios-musical-notes'
            }
            if (['doc', 'txt', 'docx', 'pages', 'epub', 'pdf'].indexOf(format) > -1) {
                type = 'document-text'
            }
            if (['numbers', 'csv', 'xls', 'xlsx'].indexOf(format) > -1) {
                type = 'stats-bars'
            }
            if (['keynote', 'ppt', 'pptx'].indexOf(format) > -1) {
                type = 'ios-videocam'
            }

            return type
        },
        onProgress(e, file) {
            if (e.percent >= 95) {
                e.percent = 95
            }
            this.loadingPrecent = e.percent
        },
        handleSuccess(res, file) {
            if (res.result === 'success') {
                this.loadingPrecent = 100
                this.loadingStatus = 'success'
                this.$refs.upload.clearFiles()
                this.$Message.info(res.msg)
                this.$emit('susccessCallback', res.data)
            } else {
                this.loadingStatus = 'wrong'
                this.$Notice.warning({
                    title: '导入失败',
                    desc: res.msg,
                    duration: 10
                })
            }
            if (_.isArray(res.data) && res.data.length) {
                this.errorData.data = res.data || []
                this.errorData.show = true
            } else {
                this.errorData.data = []
                this.errorData.show = false
                setTimeout(() => {
                    this.showProgress = false
                }, 1000)
            }
        },
        handleMaxSize(file) {
            this.loadingStatus = 'wrong'
            this.$Notice.warning({
                title: '上传失败',
                desc: '文件大小不能超过5M',
                duration: 10
            })
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: '上传失败',
                desc: '仅支持后缀为 .xls 的文件',
                duration: 10
            })
        },
        beforeUpload(file) {
            console.log('file', file)
            this.currentFile = file
            this.loadingPrecent = 0
            this.loadingStatus = 'normal'
            this.showProgress = true
            let csrfToken = Cookie.getItem('Csrf_token') || ''
            this.uploadtData.Csrf_token = csrfToken
            this.$refs.upload.clearFiles()
        },
        hideUpload() {
            this.errorData.show = false
            this.errorData.data = []
            this.currentFile = null
            this.loadingPrecent = 0
            this.loadingStatus = 'normal'
            this.showProgress = false
            this.$refs.upload.clearFiles()
            this.$emit('hideDialog')
        }
    }
}
</script>
